import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { Action, CreateActionRequest, UpdateActionRequest } from '@/shared/types/admin'

export const actionsApi = {
  getAll: () =>
    api.get<ApiResponse<Action[]>>('/api/actions').then((r) => r.data.data),

  getById: (id: number) =>
    api.get<ApiResponse<Action>>(`/api/actions/${id}`).then((r) => r.data.data),

  getActifs: () =>
    api.get<ApiResponse<Action[]>>('/api/actions/actifs').then((r) => r.data.data),

  create: (data: CreateActionRequest) =>
    api.post<ApiResponse<Action>>('/api/actions', data).then((r) => r.data.data),

  update: (id: number, data: UpdateActionRequest) =>
    api.put<ApiResponse<Action>>(`/api/actions/${id}`, data).then((r) => r.data.data),

  delete: (id: number) =>
    api.delete(`/api/actions/${id}`),
}
